import { LoadState } from "../../constants/enums";
import { IGenAiPrompt, IGenAiContext, IGenAiPromptState, IGenAiContextState, IGenAiState } from "./genAi.types";

export const defaultGenAiPrompt: IGenAiPrompt = {
  genai_prompt_uuid: null,
  company_name: "",
  collection_name: "",
  prompt: "",
  prompt_key: "",
  company_outlet_uuid: null,
  status: "ACTIVE",
};

export const defaultGenAiContext: IGenAiContext = {
  genai_context_uuid: null,
  section: "",
  content: "",
  context_key: "",
  document_id: null,
  collection_name: "",
  status: "ACTIVE",
  company_outlet_uuid: null,
};

export const defaultGenAiPromptState: IGenAiPromptState = {
  list: {
    data: [],
    totalRecords: 0,
    currentRecords: 0,
    loading: LoadState.InProgress,
    error: null,
  },
  prompt: {
    data: defaultGenAiPrompt,
    loading: LoadState.NotLoaded,
    error: null,
  },
};

export const defaultGenAiContextState: IGenAiContextState = {
  list: {
    data: [],
    totalRecords: 0,
    currentRecords: 0,
    loading: LoadState.InProgress,
    error: null,
  },
  context: {
    data: defaultGenAiContext,
    loading: LoadState.NotLoaded,
    error: null,
  },
};

export const defaultGenAiState: IGenAiState = {
  prompt: defaultGenAiPromptState,
  context: defaultGenAiContextState,
};
